import { Box, Card, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material'
import { TEXT_TITLE_COLOR } from '../../constants/colors'
import ANT_LOGO from '../../assets/images/logo.svg'

const InvoiceView = () => {
    return (
        <Box>
            <Typography variant='h4' fontWeight="bold" mb={4} color={TEXT_TITLE_COLOR}>Invoice</Typography>
            <Card sx={{ p: 2, width: 400, height: 'auto' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", ml: 3, mr: 3, mt: 3 }}>
                    <img src={ANT_LOGO} alt="logo" style={{ width: 60, height: 60 }} />
                    <Typography variant='h6' fontWeight="bold" color={TEXT_TITLE_COLOR}>ໃບຮັບເງີນ</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", ml: 2, mr: 2 }}>
                    <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 12 }}>ວັນທີ : <span style={{ color: "red" }}>01/11/2023</span> </Typography>
                    <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 12 }}>ເວລາ : <span style={{ color: "red" }}>11:11</span></Typography>
                    <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 12 }}>ເບີໂທ : <span style={{ color: "red" }}>+8562099998888</span></Typography>
                </Box>
                <Typography sx={{ ml: 2, mr: 2, mt: 1 }} fontWeight="bold" color={TEXT_TITLE_COLOR}>ເລກປະຈຳຕົວຜູ້ເສຍອາກອນ</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", ml: 2, mr: 2, mt: 1 }}>
                    <Box>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>ເລກທີ່ : 0100011</Typography>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>ພະນັກງານຂາຍ : Phat</Typography>
                    </Box>
                    <Box>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>ລະຫັດສາຂາ : SK001</Typography>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>ໜາຍເລກເຄື່ອງ : 4</Typography>
                    </Box>
                </Box>
                <Box
                    sx={{
                        border: "1px dashed #737373",
                        mr: 2,
                        ml: 2,
                        mt: 1
                    }}
                />
                {/* order map this  */}
                <TableContainer>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell sx={{ borderBottom: "none" }}>
                                    <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} sx={{ fontSize: 15 }}>Beer Laos</Typography >
                                </TableCell>
                                <TableCell align='right' sx={{ borderBottom: "none" }}>
                                    <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} sx={{ fontSize: 15 }}>1</Typography >
                                </TableCell>
                                <TableCell align='right' sx={{ borderBottom: "none" }}>
                                    <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} sx={{ fontSize: 15 }}>5,000</Typography >
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                {/* End */}
                <Box
                    sx={{
                        border: "1px dashed #737373",
                        mr: 2,
                        ml: 2,
                        mt: 1
                    }}
                />
                <TableContainer>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell sx={{ borderBottom: "none" }}>
                                    <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} sx={{ fontSize: 18 }}>ທັງໜົດ</Typography >
                                </TableCell>
                                <TableCell align='right' sx={{ borderBottom: "none" }}>
                                    <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} sx={{ fontSize: 15 }}>1</Typography >
                                </TableCell>
                                <TableCell align='right' sx={{ borderBottom: "none" }}>
                                    <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} sx={{ fontSize: 15 }}>5,000</Typography >
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', ml: 2, mr: 2 }}>
                    <Box>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>ສ່ວນຫລຸດ</Typography>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>ລວມມູນຄ່າທັງໜົດ</Typography>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>ຮັບເງີນສົດ</Typography>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>ໃຊ້ຄະເເນນເເທນເງີນສົດ</Typography>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>ຄູປອງ</Typography>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>ເງີນໂອນ</Typography>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>ບັດເຄຮດິດ</Typography>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>ເງີນທອນ</Typography>
                    </Box>
                    <Box>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>1,000</Typography>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>1,000</Typography>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>1,000</Typography>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>1,000</Typography>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>1,000</Typography>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>1,000</Typography>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>1,000</Typography>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>1,000</Typography>
                    </Box>
                </Box>
                <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} sx={{ fontSize: 16, mr: 2, ml: 2, mt: 1 }}>ຊື່ສະມາຊີກ :</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', ml: 2, mr: 2 }}>
                    <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>ຄະເເນນຄັ້ງກ່ອນ : 0</Typography>
                    <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>ຄະເເນນທີ່ໃຊ້ຄັ້ງນີ້ : 0</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', ml: 2, mr: 2 }}>
                    <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>ຄະເເນນເພີ່ມຄັ້ງນີ້ : 0</Typography>
                    <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 15 }}>ຄະເເນນສະສົມລວມ : 0</Typography>
                </Box>
                <Box mt={2} mb={1}>
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR}>*** ລາຍການສີນຄ້າລວມ ອມພ ເເລ້ວ ***</Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Typography fontWeight="bold" color={TEXT_TITLE_COLOR}>ຂອບໃຈທຸກທ່ານທີ່ມາອຸດໜູນ</Typography>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', ml: 2, mr: 2 }}>
                    <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 13 }}>ຜູ້ສັ່ງພີມ : 0</Typography>
                    <Typography fontWeight="bold" color={TEXT_TITLE_COLOR} style={{ fontSize: 13 }}>ວັນທີພີມເອກະສານ :  <span style={{ color: "red" }}>01/11/2023</span></Typography>
                </Box>
                <Box
                    sx={{
                        border: "1px dashed #737373",
                        mr: 2,
                        ml: 2,
                        mt: 1,
                        mb: 4
                    }}
                />
            </Card>
        </Box>
    )
}

export default InvoiceView